import Button from 'components/_UI/Button';
import Modal from 'components/_UI/Modal';
import Text from 'components/_UI/Text';
import { useStepRegister } from 'context/login/StepRegister';
import React from 'react';
import buttonText from 'texts/buttons/buttonText';
import colors from 'theme/colors';
import sizes from 'theme/sizes';

function InfoModalSteps({modalOpen, setModalOpen}) {
    const { stepRegister } = useStepRegister();

    const handleColorStep = (step) => {
        if (step < stepRegister) {
            return colors.successDark
        } 
        
        return colors.night
    };

    return (
        <Modal
            title='Etapas do cadastro'
            onClose={() => setModalOpen(false)}
            isOpen={modalOpen}
            align='left'
        >
            <Text type='bold'> Informações basicas: </Text>
            <Text name='small' color={handleColorStep(1)}>- Nome *</Text>
            <Text name='small' color={handleColorStep(1)}>- Sobrenome *</Text>
            <Text name='small' color={handleColorStep(1)}>- Data de nascimento *</Text>

            <Text type='bold' marginTop={sizes.normal}> Informações sobre você: </Text>
            <Text name='small' color={handleColorStep(2)}>- Email *</Text>
            <Text name='small' color={handleColorStep(2)}>- Número de telefone *</Text>
            <Text name='small' color={handleColorStep(2)}>- CPF *</Text>

            <Text type='bold' marginTop={sizes.normal}> Informações sobre seu usuário: </Text>
            <Text name='small' color={handleColorStep(3)}>- Nome de usuário *</Text>
            <Text name='small' color={handleColorStep(3)}>- Senha *</Text>
            <Text name='small' color={handleColorStep(3)}>- Confirmação da senha *
            </Text>

            <Button
                variant='primary'
                marginTop={sizes.normal}
                onClick={() => setModalOpen(false)}
            >
                {buttonText.understood}
            </Button>
        </Modal>
    )
};

export default InfoModalSteps;